<template>
  <div v-loading="loading" class="pin">
    <div class="school-title text-left">管理员列表</div>
    <div class="school-line"></div>
    <div style="margin: 15px 0">
      <el-input placeholder="请输入姓名" maxlength="20" v-model="input" clearable style="width: 250px">
      </el-input>
      <el-input placeholder="请输入手机号" maxlength="11" v-model="input1" clearable style="width: 250px">
      </el-input>
      <el-button type="primary" size="small" @click="manageuserlist(1)">搜索</el-button>
      <el-button type="primary" size="small" @click="tian(1)">添加管理员</el-button>
    </div>
    <el-table :row-style="{ height: '48px' }" :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
      :data="tableData" border stripe style="width: 100%" highlight-current-row>
      <el-table-column type="index" align="center"></el-table-column>
      <el-table-column prop="name" label="姓名" align="center"></el-table-column>
      <el-table-column prop="account" label="账号" align="center"></el-table-column>
      <el-table-column prop="mobile" label="手机号" align="center"></el-table-column>
      <el-table-column prop="roleName" label="所属角色" align="center"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="bian(scope.row)">编辑</el-button>
          <el-button type="text" @click="groupmanagerid(scope.row.id)">重置密码</el-button>
          <el-button type="text" @click="jin(scope.row)" v-if="scope.row.accountStatus"
            style="color: red">禁用</el-button>
          <el-button type="text" @click="jin(scope.row)" v-if="!scope.row.accountStatus">启用</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="margin-top: 15px" background layout="total,prev,pager,next,sizes" :hide-on-single-page="true"
      :total="totalCount" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" :current-page="curPage"
      @current-change="gai" @size-change="handleSizeChange"></el-pagination>

    <el-dialog :title="title" :visible.sync="dialogVisible" width="500px" class="left">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="90px" class="demo-ruleForm">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="ruleForm.name" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="ruleForm.sex">
            <el-radio label="0">男</el-radio>
            <el-radio label="1">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="账号" prop="account">
          <el-input v-model="ruleForm.account" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="ruleForm.mobile" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="备注/描述">
          <el-input type="textarea" :rows="4" placeholder="请输入备注/描述" v-model="ruleForm.description">
          </el-input>
        </el-form-item>
        <el-form-item style="text-align: right">
          <el-button type="primary" size="small" @click="submitForm('ruleForm')">确定</el-button>
          <el-button size="small" @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import * as homeApi from '@/api/home'
export default {
  data() {
    return {
      loading: false,
      input: '',
      input1: '',
      tableData: [],
      curPage: 1,
      pageSize: 20,
      title: '',
      dialogVisible: false,
      totalCount: 0,
      ruleForm: {
        name: '',
        sex: '0',
        account: '',
        mobile: '',
        description: ''
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }]
      },
      id: '',
      schoolId: ''
    }
  },
  watch: {},
  methods: {
    manageuserlist(s) {
      let that = this
      if (s) {
        that.curPage = 1
      }
      that.loading = true
      let params = {
        curPage: that.curPage,
        pageSize: that.pageSize,
        name: that.input,
        mobile: that.input1,
        schoolId: that.schoolId,
        roleType: 'director'
      }
      homeApi
        .manageuserlist(params)
        .then(res => {
          that.loading = false
          that.tableData = res.data.data.dataList
          that.totalCount = res.data.data.totalCount
        })
        .catch(() => {
          that.loading = false
        })
    },
    gai(s) {
      this.curPage = s
      this.manageuserlist()
    },

    handleSizeChange(val) {
      this.curPage = 1
      this.pageSize = val
      this.manageuserlist()
    },

    tian(s) {
      if (s == 1) {
        this.title = '添加管理员'
      } else {
        this.title = '编辑管理员信息'
      }
      this.id = ''
      this.ruleForm.name = ''
      this.ruleForm.sex = '0'
      this.ruleForm.account = ''
      this.ruleForm.mobile = ''
      this.ruleForm.roleType = ''
      this.ruleForm.description = ''
      this.dialogVisible = true
    },
    submitForm(formName) {
      let that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.loading = true
          if (!/^1[345789]\d{9}/.test(that.ruleForm.mobile)) {
            that.$message('请输入正确的手机号！')
            return false
          }
          let params = {
            account: that.ruleForm.account,
            roleType: 'director',
            roleName: '教管中心管理员',
            name: that.ruleForm.name,
            sex: that.ruleForm.sex,
            id: that.id,
            mobile: that.ruleForm.mobile,
            description: that.ruleForm.description,
            schoolId: that.schoolId
          }
          homeApi
            .manageusersave(params)
            .then(res => {
              if (res.data.code == 0) {
                that.$message({
                  message: that.id == '' ? '添加成功！' : '修改成功！',
                  type: 'success'
                })
                that.dialogVisible = false
                that.curPage = 1
                that.manageuserlist()
              } else {
                that.$message(res.data.msg)
              }
              that.loading = false
            })
            .catch(() => {
              that.$message('加载失败！')
              that.loading = false
            })
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.dialogVisible = false
    },
    bian(s) {
      this.title = '编辑管理员信息'
      this.ruleForm.name = s.name
      this.ruleForm.sex = s.sex.toString()
      this.ruleForm.account = s.account
      this.ruleForm.mobile = s.mobile
      this.ruleForm.roleType = s.roleType
      this.ruleForm.description = s.description
      this.id = s.id
      this.dialogVisible = true
    },
    groupmanagerid(s) {
      this.$confirm('此操作将重置此账号密码为000000, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          let that = this
          that.loading = true
          let params = {
            id: s
          }
          homeApi
            .resetPwds(params)
            .then(res => {
              that.$message({
                type: 'success',
                message: '重置成功!'
              })
              that.loading = false
            })
            .catch(() => {
              that.loading = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    jin(s) {
      this.$confirm(
        s.accountStatus
          ? '将禁用此账号登录系统的权限, 是否继续?'
          : '将启用此账号登录系统的权限, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.loading = true
          let that = this
          that.loading = true
          let params = {
            roleType: s.roleType,
            userId: s.id,
            status: s.accountStatus ? 2 : 1
          }
          homeApi
            .usercentermodifyStatus(params)
            .then(res => {
              if (res.data.code == '0') {
                that.$message({
                  type: 'success',
                  message: '操作成功!'
                })
                that.loading = false
                that.manageuserlist()
              } else {
              }
              that.loading = false
            })
            .catch(() => {
              that.loading = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    }
  },
  mounted() {
    this.schoolId = JSON.parse(localStorage.getItem('info')).schoolId
    this.manageuserlist()
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/school/components/operation.vue